import axios from "axios";
import decode from 'jwt-decode';

export default class AuthService {
    // Initializing important variables
    constructor() {
        this.domain = 'https://onamfc.com/api/login' // API server domain
    }

    static setToken(idToken) {
        // Saves user token to localStorage
        localStorage.setItem('_htk', idToken)
    }

    static getToken() {
        // Retrieves the user token from localStorage
        return localStorage.getItem('_htk')
    }

    static setUser(user) {
        // set the user object in localstorage
        localStorage.setItem('_htu', JSON.stringify(user))
    }

    static getUser() {
        return localStorage.getItem('_htu')
    }

    static decodeToken() {
        // Using jwt-decode npm package to decode the token
        return decode(AuthService.getToken());
    }

    static assessmentCompleted() {
        let user = JSON.parse(AuthService.getUser())
        return user.category_order
    }

    // only called by users that need to reset their password for logging into the new site for the first time.
    async setPassword(setObject) {
        await axios.post(this.domain, setObject).then(res => {

        })
    }

    async login(loginObj) {

        return await axios.post(this.domain, loginObj).then(response => {
            // console.log(response)
            if (response.status === 200 && response.data.status === 'change') {
                return {status: 417, email: response.data.email, token: response.data.token}
            } else {
                AuthService.setToken(response.data.token)
                AuthService.setUser(response.data.user)
                return {}
            }


            // console.log("Completed: ", completed);
            // console.log("Props :", this.props);
            // this.props.checkQuestionsCompleted(completed);
        }).catch(err => {

            // err.response.status === 417 && window.location.replace('/');
        })
    }

    static loggedIn() {
        const token = AuthService.getToken()
        return !!token && !AuthService.isTokenExpired(token)
    }

    static logout() {
        // Clear user token and profile data from localStorage
        localStorage.removeItem('_htk');
        localStorage.removeItem('_htu');
    }

    static isTokenExpired(token) {
        try {
            const decoded = decode(token);
            return (decoded.exp < Date.now() / 1000);
        } catch (err) {
            return false;
        }
    }

}
